import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useCustomModal } from '../../../../hooks/useCustomModal';
import { getCosmeticCommissions } from '../../../../appRedux/actions';
import {
  commissionConst,
  filterNoApprove,
  filters,
  filtersMedical,
  searchFiltersCosmetology,
  searchInputInitialValues,
} from '../../../../constants/Commissions.const';
import { ListTable, ModalView, TableFilters } from '../../../uiComponents';
import { formatPrice } from '../../../../util/formatPrice';
import { mainBranch } from '../../../../constants/Branch.const';
import { Button } from 'antd';
import { CosmetologyCommissionModalBody } from '../CosmetologyCommissionModalBody';
import { roleConst } from '../../../../constants';

export const CommissionComestology = () => {
  const { cosmetologic_comission: cosmetologyPrivileges = [], role } =
    useSelector((state) => state.userAuth);
  const { branchId: loggedBranchId, branch: branchLogged } = useSelector(
    (state) => state.userAuth
  );
  const [title, setTitle] = useState({});
  const { modal } = useCustomModal();
  const [child, setChild] = useState();
  const getCommissions = getCosmeticCommissions;
  const approvePrivilege = cosmetologyPrivileges.includes('approve');
  let applicabeFilter;

  if (roleConst.cosmetologist === role) {
    applicabeFilter = filtersMedical;
  } else if (!approvePrivilege) {
    applicabeFilter = filterNoApprove;
  } else {
    applicabeFilter = filters;
  }

  const onModalClick = (userId, data) => {
    setTitle(
      ` ${data.name} ${data.lastName} - ${commissionConst.COSMETOLOGY_MODAL_TITLE}`
    );
    setChild(<CosmetologyCommissionModalBody id={userId} />);
    modal();
  };

  const columns = [
    {
      title: 'No. de empleado',
      sorter: true,
      dataIndex: 'employeeNumber',
      key: 'employeeNumber',
      render: (_, data) => (
        <Button
          type="link"
          htmlType="button"
          onClick={() => onModalClick(data.id, data)}
        >
          {data.employeeNumber}
        </Button>
      ),
    },
    {
      title: 'Nombre',
      sorter: true,
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Apellido paterno',
      sorter: true,
      dataIndex: 'lastName',
      key: 'lastName',
    },
    {
      title: 'Apellido materno',
      sorter: true,
      dataIndex: 'motherLastName',
      key: 'motherLastName',
    },
    {
      title: 'Venta semana 1',
      sorter: true,
      dataIndex: 'saleWeekOne',
      key: 'saleWeekOne',
      render: (saleWeekOne) => formatPrice(saleWeekOne),
    },
    {
      title: 'Venta semana 2',
      sorter: true,
      dataIndex: 'saleWeekTwo',
      key: 'saleWeekTwo',
      render: (saleWeekTwo) => formatPrice(saleWeekTwo),
    },
    {
      title: 'Comisión',
      sorter: true,
      dataIndex: 'commission',
      key: 'commission',
      render: (commission) => formatPrice(commission),
    },
    {
      title: 'Total venta',
      sorter: true,
      dataIndex: 'totalSale',
      key: 'totalSale',
      render: (totalSale) => formatPrice(totalSale),
    },
  ];

  return (
    <>
      <TableFilters
        privileges={cosmetologyPrivileges}
        searchFilters={searchFiltersCosmetology}
        filters={applicabeFilter}
        searchInputInitialValues={searchInputInitialValues}
        loggedBranchId={loggedBranchId}
        initialParams={
          !approvePrivilege && branchLogged !== mainBranch
            ? { branchId: loggedBranchId }
            : undefined
        }
      />
      <ListTable
        columns={columns}
        getDataFunction={getCommissions}
        privileges={cosmetologyPrivileges}
      />
      <ModalView title={title} width={1000}>
        {child}
      </ModalView>
    </>
  );
};
